"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiSuggestionsClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
class ApiSuggestionsClient extends ApiSubClient_1.ApiSubClient {
    suggest(query) {
        const suggestionHref = (0, expandUrlTemplate_1.default)(this.getLinkOrThrow('suggestions').href, { query: query });
        return this.axios.get(suggestionHref).then((response) => {
            return response.data;
        });
    }
}
exports.ApiSuggestionsClient = ApiSuggestionsClient;
//# sourceMappingURL=ApiSuggestionsClient.js.map